import { Grid } from "@mui/material";
import React, { useEffect } from "react";
import AOS from 'aos';
import 'aos/dist/aos.css'

const NumberCards = (props) => {
    useEffect(() =>{
        AOS.init({duration: 2000})
    })
    return(
        <Grid 
            xs={12}
            sm={6}
            md={3}
            className="px-3"
            data-aos={props.cardAnimate}
        >
            <div className={ props.customClass + " MS---Number_card mx-auto py-4 px-5 px-md-4 px-lg-5 " }>
                <h3 className="text-left">{props.number}</h3>
                <p className="text-left mb-0" style={{fontSize:12,color: '#878E86'}}>{props.title}</p>
                <div className="bg"></div>
            </div>
        </Grid>
    );
}

export default NumberCards;